import { useTimer, formatElapsed } from "@/context/TimerContext";
import { Button } from "@/components/ui/button";
import { Square, Timer } from "lucide-react";

export default function TimerWidget() {
  const { active, elapsed, stop } = useTimer();

  if (!active) {
    return (
      <div data-testid="timer-idle" className="hidden md:flex items-center gap-2 h-9 px-3 rounded-md border border-border text-muted-foreground text-sm">
        <Timer className="h-4 w-4" />
        <span>Sin temporizador</span>
      </div>
    );
  }

  return (
    <div data-testid="timer-active" className="flex items-center gap-2 h-9 pl-3 pr-1.5 rounded-md border border-timer/30 bg-timer/10">
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-timer opacity-60" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-timer" />
      </span>
      <div className="flex flex-col leading-none">
        <span className="font-mono text-sm font-medium text-timer tabular-nums">{formatElapsed(elapsed)}</span>
        <span className="text-[10px] text-muted-foreground max-w-[120px] truncate">{active.project_name}</span>
      </div>
      <Button
        data-testid="timer-stop-btn"
        size="icon"
        variant="ghost"
        onClick={stop}
        className="h-7 w-7 text-timer hover:bg-timer/20 hover:text-timer"
      >
        <Square className="h-3.5 w-3.5 fill-current" />
      </Button>
    </div>
  );
}
